import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';

import {
  CreateDynamicPermissionCommand,
  GetDynamicPermissionsByQueryCommand,
  GetDynamicPermissionsCommand,
  UpdateDynamicPermissionCommand,
} from './dynamic-permission.commands';
import {
  CreatedDynamicPermissionDomainEvent,
  GottenDynamicPermissionsByQueryDomainEvent,
  GottenDynamicPermissionsDomainEvent,
  UpdatedDynamicPermissionDomainEvent,
} from './dynamic-permission.events';

@Injectable()
export class DynamicPermissionEffects {
  dynamicPermissionPrefix = 'dynamic-permission';

  getDynamicPermissionsEffect!: Observable<Action<string>> & CreateEffectMetadata;
  getDynamicPermissionsByQueryEffect: Observable<Action<string>> & CreateEffectMetadata;
  createDynamicPermissionEffect: Observable<Action<string>> & CreateEffectMetadata;
  updateDynamicPermissionEffect: Observable<Action<string>> & CreateEffectMetadata;

  constructor(public sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.getDynamicPermissionsEffect = this.sciGuaduaHttpRequestHandler.handleEvent({
      command: GetDynamicPermissionsCommand,
      prefix: this.dynamicPermissionPrefix,
      others: (httpResponse: any, _commandData: any) => {
        const data = httpResponse.data;

        return [
          GottenDynamicPermissionsDomainEvent({
            dynamicPermissions: data,
          }),
        ];
      },
    });

    this.getDynamicPermissionsByQueryEffect = this.sciGuaduaHttpRequestHandler.handleEvent({
      command: GetDynamicPermissionsByQueryCommand,
      prefix: this.dynamicPermissionPrefix,
      others: (httpResponse: any, _commandData: any) => {
        const data = httpResponse.data;
        return [
          GottenDynamicPermissionsByQueryDomainEvent({
            dynamicPermissions: data,
          }),
        ];
      },
    });
    this.createDynamicPermissionEffect = this.sciGuaduaHttpRequestHandler.handleEvent({
      command: CreateDynamicPermissionCommand,
      prefix: this.dynamicPermissionPrefix,
      others: (httpResponse: any, _commandData: any) => {
        const data = httpResponse.data;
        return [
          CreatedDynamicPermissionDomainEvent({
            dynamicPermission: data,
          }),
        ];
      },
    });
    this.updateDynamicPermissionEffect = this.sciGuaduaHttpRequestHandler.handleEvent({
      command: UpdateDynamicPermissionCommand,
      prefix: this.dynamicPermissionPrefix,
      others: (httpResponse: any, _commandData: any) => {
        const data = httpResponse.data;
        return [
          UpdatedDynamicPermissionDomainEvent({
            dynamicPermission: data,
          }),
        ];
      },
    });
  }
}
